import { DataGrid } from '@mui/x-data-grid'
import './datatable.scss'
import { TableContainer, Box, Checkbox, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const DatatableAssignUsers = ({ rows, isEditing, toAssign, updateAssigns, setIsEditingAssign }) => {
  const [final, setFinal] = useState([])
  const [finalAssign, setFinalAssign] = useState([])
  const [change, setChange] = useState(false)
  const { t } = useTranslation(['common'])

  useEffect(() => {
    if (!change) {
      setFinal(
        rows?.map((element) => {
          return { ...element, id: element._id, roles: element.roles }
        }),
      )
      setFinalAssign(
        toAssign?.map((element) => {
          return { ...element, id: element._id, roles: element.roles }
        }),
      )
    }
  }, [rows, toAssign, isEditing])

  const handleCheckChange = (checked, obj) => {
    let aux = [...final]
    if (checked) {
      aux.push({ ...obj, id: obj._id, roles: obj.roles })
    } else {
      aux = aux.filter((item) => item.email !== obj.email)
    }
    setFinal([...aux])
  }

  const columns1 = [
    {
      field: '_id',
      headerName: 'ID',
      flex: 1,
      minWidth: 100,
      hide: true,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        return params.row.email
      },
    },
    {
      field: 'roles',
      headerName: 'Roles',
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return params.row.roles ? params.row.roles.join(',') : '---'
      },
    },
  ]

  const columns2 = [
    {
      field: '_id',
      headerName: 'ID',
      flex: 1,
      minWidth: 100,
      hide: true,
    },
    {
      field: 'checkbox',
      headerName: 'Checkbox',
      renderCell: (params) => {
        return (
          <Box>
            <Checkbox
              checked={final.map((e) => e.email).includes(params.row.email)}
              onChange={(e) => {
                handleCheckChange(e.target.checked, params.row)
              }}
            />
          </Box>
        )
      },
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        return params.row.email
      },
    },
    {
      field: 'roles',
      headerName: 'Roles',
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return params.row.roles ? params.row.roles.join(',') : '---'
      },
    },
  ]

  return (
    <Box>
      {!isEditing && (
        <TableContainer>
          <DataGrid
            getRowId={(row) => row._id || row.id}
            rows={Array.isArray(final) && final.length ? final : []}
            columns={columns1}
            hideFooter={true}
            autoHeight={true}
          />
        </TableContainer>
      )}
      {isEditing && (
        <Box className="assign-users">
          <TableContainer>
            <DataGrid
              getRowId={(row) => row._id || row.id}
              rows={Array.isArray(finalAssign) && finalAssign.length ? finalAssign : []}
              columns={columns2}
              hideFooter={true}
              autoHeight={true}
            />
          </TableContainer>
          <Box className="assign-users-button">
            <Button
              onClick={() => {
                setIsEditingAssign(false)
                updateAssigns(
                  final.map((e) => {
                    if (e._id) return e._id
                    else return e.id
                  }),
                )
                setChange(true)
              }}
              size="small"
              variant="contained"
            >
              {t('common:save')}
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default DatatableAssignUsers
